import { Container, Stack } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { selectRequiresAccessAcknowledgement } from '@bvi/dashboard/entities/user-auth/selectors';
import { AccessAcknowledgementModal } from '@bvi/dashboard/feature/auth/ui/access-acknowledgement-modal';

import { AppFooter } from '../AppFooter';

import { Header } from './Header';

export const DashboardLayout: FC<PropsWithChildren> = ({ children }) => {
  const requiresAccessAcknowledgement = useSelector(
    selectRequiresAccessAcknowledgement(),
  );

  return (
    <Stack minHeight="100vh">
      <Header />
      <Container
        maxWidth="xl"
        sx={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
          pb: 0,
        }}
      >
        {children}
      </Container>
      <AppFooter />
      {requiresAccessAcknowledgement && <AccessAcknowledgementModal />}
    </Stack>
  );
};
